/**
 * Created by andrey on 01.02.2021.
 */

const HeroDetailsLayout = FamilyLayout.extend({
    ctor: function (hero, units, options) {
        if (hero.unknownHero) {
            options.title = Messages.get("Units.unknownHero.title");
            options.unknownHero = true;
        }
        this.units = units;
        const styles = cleverapps.styles.HeroDetailsLayout;
        options.height = styles.height;

        this.searchUnit = options.searchUnit;

        const icons = units.map((unit) => new UnitLibraryIcon(unit));

        this._super(hero.code, icons, options);

        this.hero = hero;

        if (bundles.unitslibrarywindow.frames.horizontal_scroll_foreground) {
            const foreground = cleverapps.UI.createScale9Sprite(bundles.unitslibrarywindow.frames.horizontal_scroll_foreground, cleverapps.UI.Scale9Rect.TwoPixelXY);
            foreground.setAnchorPoint(0, 0);

            const foregroundRect = cc.rectSubPadding(cc.rect(0, 0, this.background.width, this.background.height), cc.padding(styles.foreground.padding));
            foreground.setContentSize2(foregroundRect);
            foreground.setAlignment(foregroundRect);
            this.background.addChild(foreground);
        }

        if (!hero.unknownHero) {
            this.createButtonInfo();
        }

        this.createHeroInfoText();

        cleverapps.eventBus.on("unitStatusChanged", this.onUnitStatusChanged.bind(this), this);

        // this.debugBorder();

        this.createHeroIcon();

        this.title.setAlignment(styles.title);
    },

    onUnitStatusChanged: function (unit) {
        if (unit.code !== this.hero.code) {
            return;
        }

        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.DelayTime(1.0),
            new cc.CallFunc(this.scrollToFresh.bind(this))
        ));
    },

    scrollToFresh: function () {
        this.stopAllActions();

        const unit = this.searchUnit && Unit.findUnit(this.units, this.searchUnit)
            || cleverapps.unitsLibrary.findFreshUnit(this.units)
            || cleverapps.unitsLibrary.findLastOpenedUnit(this.units);
        const index = unit ? this.units.indexOf(unit) : this.units.length - 1;

        const icon = this.icons[index];

        if (icon && this.scroll) {
            this.scroll.runAction(new cc.Sequence(
                new cc.DelayTime(0.5),
                new cc.ScrollAction(icon, {
                    duration: 1.6,
                    visibleBox: {
                        left: 0.96,
                        right: 0.96
                    }
                }).easing(cc.easeBackInOut())
            ));
        }
    },

    createHeroInfoText: function () {
        const styles = cleverapps.styles.HeroDetailsLayout;

        const text = this.hero.unknownHero ? "Units.unknownHero.details" : `Units.${this.hero.code}.describe`;

        const heroInfoText = this.heroInfoText = cleverapps.UI.generateOnlyText(Messages.get(text), cleverapps.styles.FONTS.HERODETAILS_TEXT);
        heroInfoText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        heroInfoText.setVerticalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        heroInfoText.setAlignment(styles.infoHeroText);

        const size = styles.infoHeroText.size[this.options.resolutionMode] || styles.infoHeroText.size;
        heroInfoText.setDimensions(size.width, size.height);
        
        this.background.addChild(heroInfoText);

        this.grid.setCascadeOpacityEnabledRecursively(true);

        this.setCascadeOpacityEnabledRecursively(true);

        heroInfoText.setVisible(this.hero.unknownHero);
    },

    createButtonInfo: function () {
        const styles = cleverapps.styles.HeroDetailsLayout.buttonInfo;

        if (!styles || cleverapps.flags.largeTextHotfix) {
            return;
        }

        let info = false;

        const button = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.hero_help_button,
            callback: function () {
                if (!this.heroInfoText) {
                    this.createHeroInfoText();
                }

                const toShow = info ? this.grid : this.heroInfoText;
                const toHide = info ? this.heroInfoText : this.grid;

                info = !info;

                button.setType(info ? cleverapps.styles.UI.Button.Images.help_button_return
                    : cleverapps.styles.UI.Button.Images.hero_help_button);

                toShow.stopAllActions();
                toShow.setOpacity(0);
                toShow.setVisible(true);
                toShow.runAction(new cc.Sequence(
                    new cc.DelayTime(0.15),
                    new cc.FadeTo(0.15, 255)
                ));

                toHide.stopAllActions();
                toHide.setOpacity(255);
                toHide.runAction(new cc.Sequence(
                    new cc.FadeTo(0.15, 0),
                    new cc.Hide()
                ));
            }.bind(this) 
        });
        button.setLocalZOrder(1);
        button.setAlignment(styles);
        this.addChild(button);
        this.helpButton = button;
    },

    createGrid: function (icons) {
        const styles = cleverapps.styles.HeroDetailsLayout.grid;

        icons = this.decorateIconsWithText(icons);

        const grid = new cleverapps.GridLayout(icons, {
            columns: icons.length,
            align: {
                y: cleverapps.GridLayout.ALIGN_END
            },
            padding: styles.padding,
            margin: styles.margin,
            separator: this.gridSeparator()
        });

        // grid.debugBorder();

        const width = styles.size[this.options.resolutionMode].width;

        if (grid.width <= width) {
            grid.setAlignment(styles.position);
            return grid;
        }

        const scroll = this.scroll = new cleverapps.UI.ScrollView(grid, {
            childrenVisibility: false,
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_HORIZONTAL
        });
        scroll.setContentSize(width, grid.height);
        scroll.setAlignment(styles.scroll);

        // scroll.debugBorder();

        scroll.scrollTo(cleverapps.UI.ScrollView.SCROLLS.LOWER_RIGHT);
        this.scrollToFresh();
        return scroll;
    },

    createHeroIcon: function () {
        const styles = cleverapps.styles.HeroDetailsLayout;

        if (!styles.heroIcon) {
            return;
        }

        const heroIcon = new HeroIcon(this.hero);
        heroIcon.setAlignment(styles.heroIcon.position);
        heroIcon.setScale(styles.heroIcon.scale);
        heroIcon.updateState();
        this.addChild(heroIcon);
        this.heroIcon = heroIcon;

        cleverapps.eventBus.on("unitStatusChanged", heroIcon.updateState.bind(heroIcon), this);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    HERODETAILS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.overrideTemplates(cleverapps.styles.UI.Button.Images, {
    hero_help_button: {
        button_png: bundles.help_button.frames.help_button_light_png,
        button_on_png: bundles.help_button.frames.help_button_light_on_png
    }
});

cleverapps.styles.HeroDetailsLayout = {
    height: 320,

    infoHeroText: {
        x: { align: "center", dx: 120 },
        y: { align: "center", dy: -30 },

        size: [{ width: 670, height: 220 }, { width: 1066, height: 220 }, { width: 1066, height: 220 }]
    },

    title: {
        x: { align: "center" },
        y: { align: "top" }
    },

    buttonInfo: {
        x: { align: "right", dx: -50 },
        y: { align: "top", dy: -50 }
    },

    grid: {
        size: [{
            width: 1868
        }, {
            width: 1868
        }, {
            width: 1868
        }],

        position: {
            x: { align: "left", dx: 4 },
            y: { align: "center", dy: -15 }
        },

        scroll: {
            x: { align: "left", dx: 4 },
            y: { align: "center", dy: -15 }
        },

        padding: {
            x: 50,
            top: 30,
            bottom: 70
        },

        margin: {
            x: 54,
            y: 20
        }
    },

    heroIcon: {
        position: {
            x: { align: "left", dx: 20 },
            y: { align: "center" }
        },

        scale: 1
    },

    foreground: {
        padding: {
            top: 80,
            bottom: 65
        }
    }
};
